import React from "react";
import BurgerMenu from "../../img/svg/burger_menu.svg";
import BurgerMenuleumit from "../../img/svg/burger_menu_leumit.png";
import BurgerMenuMaoflaamit from "../../img/svg/burger_menu_maoflaamit.png";
import { setSidebarOpened } from "../../store/mainSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isPartnerLeumit, isPartnerMaoflaamit, selectPartner } from "../../store/partnerStore";
import { isV2Enabled, V2_SCREEN_KEYS } from "../../v2/registry";

const HeaderIconBurger = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLeumit = useSelector(isPartnerLeumit);
  const isMaoflaamit = useSelector(isPartnerMaoflaamit);
  const partner = useSelector(selectPartner);

  // V2 partners get the routed profile page instead of the legacy drawer.
  const handleClick = () =>
    isV2Enabled(V2_SCREEN_KEYS.PROFILE, partner) ? navigate("/profile") : dispatch(setSidebarOpened(true));

  return (
    <div className="burger_menu mt-5" onClick={handleClick}>
      <img src={isLeumit ? BurgerMenuleumit : isMaoflaamit ? BurgerMenuMaoflaamit : BurgerMenu} alt="burger menu" style={{ width: "23px" }} />
    </div>
  );
};

export default HeaderIconBurger;
